export default __webpack_public_path__ + "images/UZ.f7cdca4.png";